export default __webpack_public_path__ + "static/normalFont-6cf113f87d169b4be3bb836fb0eec60d.woff";